import Loader from '@components/LayoutComponents/Loader'
import IndexLayout from '@components/layouts'
import React, { Suspense } from 'react'
import {
  createHashRouter,
  Navigate,
  Outlet,
  RouterProvider,
} from 'react-router-dom'

import TopSelectorSet from './components/TopSelectorSet'
import { routes } from './routes'

const Router = () => {
  const router = createHashRouter([
    {
      path: '/',
      element: (
        <IndexLayout>
          <Outlet />
        </IndexLayout>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="/verticals/list" replace />,
        },
        ...routes.reduce((routes, route) => renderRoute(routes, route, ''), []),
      ],
    },
  ])

  return <RouterProvider router={router} />
}

export default Router

function renderRoute(routes, route, parentPath) {
  const path = parentPath + '/' + route.path

  if (route.component) {
    routes.push({
      path: path,
      element: LazyRendering(route.component.Component, route.component.params),
    })
  }

  if (route.children) {
    route.children.reduce(
      (routes, childRoute) => renderRoute(routes, childRoute, path),
      routes,
    )
  }

  return routes
}

function LazyRendering(
  Component,
  _props = { topSelector: undefined, types: undefined },
) {
  return (
    <Suspense fallback={<Loader />}>
      <TopSelectorSet topSelector={_props.topSelector} types={_props.types}>
        <Component {..._props} />
      </TopSelectorSet>
    </Suspense>
  )
}
